export default __webpack_public_path__ + "static/media/streaks 200.b1c34db6.svg";